import { useState } from 'react'
import { useMatch } from 'react-router-dom'
import { Button, Popover, Stack } from '@mantine/core'
import { IconUsers, IconVideo } from '@tabler/icons-react'
import { useAppFlags } from '@/hooks/useAppFlags'
import { usePatientSidePanel } from './PatientSidePanelContext.tsx'

export function NewEncounterChartAction() {
  const { newEncounter } = useAppFlags<{ newEncounter?: boolean }>()
  const { openPanel } = usePatientSidePanel()
  const [opened, setOpened] = useState(false)
  const isCallPage = useMatch('/call/:encounterId/*')

  if (!newEncounter || isCallPage) {
    return null
  }

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
      width="target"
      shadow="md"
      withArrow
      withinPortal={false}
    >
      <Popover.Target>
        <Button mb="sm" size="xs" fullWidth variant="light" onClick={() => setOpened((o) => !o)}>
          New Encounter
        </Button>
      </Popover.Target>
      <Popover.Dropdown p={4}>
        <Stack gap={2}>
          <Button
            variant="subtle"
            justify="flex-start"
            fullWidth
            size="sm"
            leftSection={<IconVideo size={16} />}
            onClick={() => {
              setOpened(false)
              openPanel({ panelType: 'newEncounterSoap' })
            }}
          >
            Virtual Visit
          </Button>
          <Button
            variant="subtle"
            justify="flex-start"
            fullWidth
            size="sm"
            leftSection={<IconUsers size={16} />}
            onClick={() => {
              setOpened(false)
              openPanel({ panelType: 'careCoordinator' })
            }}
          >
            Care Coordinator
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  )
}
